import { Component, OnInit, Input } from '@angular/core';
import { TernaryDecision, Languages, Service } from 'src/app/shared/models/enums.model';
import { UserResponseDto } from '../../models/adminResponseDto';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { AdminDecisionService } from '../../services/admin-decision.service';
import { BaseRequestService } from '../../services/base-request.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-user-decision',
  templateUrl: './user-decision.component.html',
  styleUrls: ['./user-decision.component.css']
})
export class UserDecisionComponent implements OnInit {
  UserDecisionForm: FormGroup;
  ServiceID: number;
  readonly: boolean;
  requestId: any;
  submitted: boolean = false;
  isAccepted: boolean = true;
  isRejected: boolean = false;
  isRequiredModifications: boolean = false;
  ternaryDecision = TernaryDecision;
  ternaryDecisionKeys = Object.keys(this.ternaryDecision);
  Services = Service;
  showRequest = true;
  isRequestHistory :boolean = false;
  userIsReject : boolean = false;
  rejectionReasons : string ;
  userIsRequireModification : boolean = false;
userRequireModification : string ;
userAccept : boolean = false;
responseObject: ResponseObject;
isErrorMessage: boolean = false;



  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute, private global: GlobalServices, private adminDecisionService: AdminDecisionService, private baseRequestService: BaseRequestService, private authSrevice: AuthenticationService) {
    if (history.state.data && history.state.data.requestId){
    this.requestId = history.state.data.requestId;
    } else {
      window.history.back();
    }
    // this.requestId = this.route.snapshot.params.Id;
    this.ternaryDecisionKeys = this.ternaryDecisionKeys.slice(this.ternaryDecisionKeys.length / 2);
    this.readonly = true;
  }

  ngOnInit() {
    if (history.state.data && history.state.data.isCompleted){
      this.isRequestHistory = true;
     }
    this.reactiveForm();

    this.ternaryDecision;
    this.baseRequestService.getServiceIdByRequestId(this.requestId).subscribe(
      s => {
        this.ServiceID = s.Data;
      });
      this.getAdminDecision();
  }

  get Validate() {
    return this.UserDecisionForm.controls;
  }

  reactiveForm() {
    this.UserDecisionForm = this.formBuilder.group({
      TDecision: ['', [Validators.required]],

    });
  }

  userDecisionChoice(choice: number) {
    if (choice == this.ternaryDecision.Accept) {
      if (this.UserDecisionForm.controls['UserRejectionReasons'] != null)
        this.UserDecisionForm.removeControl('UserRejectionReasons');
      if (this.UserDecisionForm.controls['UserRequiredModifications'] != null)
        this.UserDecisionForm.removeControl('UserRequiredModifications');
      this.isRejected = false;
      this.isRequiredModifications = false;
    }
    else if (choice == this.ternaryDecision.Reject) {
      this.UserDecisionForm.addControl('UserRejectionReasons',  new FormControl('', [Validators.required]));
      if (this.UserDecisionForm.controls['UserRequiredModifications'] != null)
        this.UserDecisionForm.removeControl('UserRequiredModifications');
      this.isRejected = true;
      this.isRequiredModifications = false;
    }
    else if (choice == this.ternaryDecision.RequiredModifications) {
      this.UserDecisionForm.addControl('UserRequiredModifications', new FormControl('', [Validators.required]));
      if (this.UserDecisionForm.controls['UserRejectionReasons'] != null)
        this.UserDecisionForm.removeControl('UserRejectionReasons');
      this.isRejected = false;
      this.isRequiredModifications = true;
    }
  }

  ShowRequiredModificationDecision(curr: number) {
    return curr != this.ternaryDecision.RequiredModifications ? true : (this.ServiceID == this.Services.FiberGlass && curr == this.ternaryDecision.RequiredModifications) ? true : false;
  }

  userResponse() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.UserDecisionForm.invalid) {
      return;
    }
    //Enable Loader
    this.global.isLoaderEnabled = true;
    var responseResult = new UserResponseDto();
    responseResult.response = this.UserDecisionForm.controls.TDecision.value;
    responseResult.requestId = this.requestId;
    responseResult.userName = this.authSrevice.currentUserValue.UserName;
    responseResult.serviceId = this.ServiceID;
    if (responseResult.response == this.ternaryDecision.Reject) {
      responseResult.UserRejectionReasons = this.UserDecisionForm.controls.UserRejectionReasons.value;
      responseResult.UserRequiredModifications = null;
    }
    else if (responseResult.response == this.ternaryDecision.RequiredModifications)
      responseResult.UserRequiredModifications = this.UserDecisionForm.controls.UserRequiredModifications.value;
    this.adminDecisionService.setUserResponse(responseResult).subscribe(
      (data: ResponseObject) => {
        this.responseObject = data;
if(this.responseObject.Success){
  this.showRequest = false;
  //Disable Loader
  this.global.isLoaderEnabled = false;
}else{
          this.isErrorMessage = true;
          this.showRequest = false;
          this.global.isLoaderEnabled = false;

          //Disable Loader
}

      });
  }


    getAdminDecision() {
      this.adminDecisionService.getAdminDecision(this.requestId).subscribe(
        d => {
          if (d.Data.UserRejectionReasons){
            this.userIsReject = true;
            this.rejectionReasons = d.Data.UserRejectionReasons;
          }
          else if(d.Data.RequiredModifications){
            this.userIsRequireModification = true;
            this.userRequireModification = d.Data.RequiredModifications;
          }else{
            this.userAccept = true;
          }

          });


     }



  }






